import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './Accordion.style';
import ProductLines, { ContentDetails } from '../ProductLines';

const AccordionContentContainer = themeStyles.apply(Box, 'AccordionContentContainer');

const AccordionContent = ({ productLines, subItems }) => {
  const { t } = useTranslation();
  if (!productLines.length || !subItems) return null;

  return (
    <AccordionContentContainer>
      <ProductLines leftAlign>
        {productLines.map(({ iconName, dictionaryLabel, productLineName }) => {
          const productLineSubItem = subItems?.[productLineName];
          const productLineSubItems =
            Array.isArray(productLineSubItem) && productLineSubItem.length > 0 ? productLineSubItem.join(', ') : '';
          return (
            <ContentDetails
              key={iconName}
              iconName={iconName}
              title={t(`Sub-apps.Dealers.${dictionaryLabel}`)}
              isTitleBold
              subTitle={productLineSubItems}
              testId={`cy-${iconName}-productLine`}
            />
          );
        })}
      </ProductLines>
    </AccordionContentContainer>
  );
};

AccordionContent.defaultProps = {
  productLines: [],
  subItems: {},
};

AccordionContent.propTypes = {
  productLines: PropTypes.arrayOf(
    PropTypes.shape({
      categories: PropTypes.arrayOf(PropTypes.string),
      financialOptions: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
    }),
  ),
  subItems: PropTypes.shape({}),
};

export default AccordionContent;
